import {createTableState, normalizePagination} from '@/core/services/Helper'
import {ElMessageBox} from 'element-plus'

// Lokalizasyon varlıkları için ortak CRUD store fabrikası (kod/ad bazlı, çeviri yok).
// payload doğrudan gönderilir.
export default function makeCrud(endpointKey) {
    return {
        namespaced: true,
        state: () => ({table: createTableState(), filterData: undefined}),
        getters: {},
        actions: {
            async get({state, commit}, {page, filterData}) {
                commit('setLoading', true)
                state.filterData = filterData

                let params = {page: page?.current, page_limit: page?.pageSize}
                if (state.filterData) params = {...params, ...state.filterData}

                const res = await this._vm.axios.get(this._vm.endpoint.get(endpointKey), {params})
                const {data, meta} = res.data

                commit('updateTableData', data)
                commit('updatePagination', normalizePagination(meta))

                setTimeout(() => commit('setLoading', false), 250)
            },

            refresh({state, dispatch}) {
                dispatch('get', {page: state.table.pagination, filterData: state.filterData})
            },

            async show(_, {id}) {
                const response = await this._vm.axios.get(this._vm.endpoint.get(endpointKey) + '/' + id)
                return response.data.data
            },

            async create(_, {data}) {
                const response = await this._vm.axios.post(this._vm.endpoint.get(endpointKey), data)
                return response.data
            },

            async put(_, {id, data}) {
                const response = await this._vm.axios.put(this._vm.endpoint.get(endpointKey) + '/' + id, data)
                return response.data
            },

            async delete({dispatch}, {id}) {
                let successDeleted = []
                if (id.length === 0) {
                    this._vm.$message.warning(this._vm.$t('messages.selectRow'))
                } else {
                    // Silmeden önce onay iste (tak diye silmesin)
                    try {
                        await ElMessageBox.confirm(
                            this._vm.$t('mgr.common.deleteConfirm'),
                            this._vm.$t('mgr.common.deleteConfirmTitle'),
                            {
                                confirmButtonText: this._vm.$t('mgr.common.delete'),
                                cancelButtonText: this._vm.$t('mgr.common.cancel'),
                                type: 'warning',
                                confirmButtonClass: 'el-button--danger',
                            }
                        )
                    } catch (e) {
                        return successDeleted   // iptal edildi
                    }

                    for (let i = 0; i < id.length; i++) {
                        const {data} = await this._vm.axios.delete(this._vm.endpoint.get(endpointKey) + '/' + id[i])
                        if (data.status) {
                            this._vm.$message.success(this._vm.$t('messages.deleteOk'))
                            successDeleted.push(id[i])
                        } else {
                            this._vm.$message.error(data.message)
                        }
                    }
                    dispatch('refresh')
                    return successDeleted
                }
            },
        },
        mutations: {
            setLoading(state, val) {
                state.table.loading = val
            },
            updatePagination(state, pagination) {
                state.table.pagination = pagination
            },
            updateTableData(state, data) {
                state.table.data = data
            },
        },
    }
}
